export class MarketplaceTemplate {
    constructor() {
        this.router = '';
        this.subBots = [];
        this.name = '';
        this.image = '';
        this.imageUrl = '';
        this.tags = [];
        this.channels = [];
        this.description = '';
        this.ownerIdentity = '';
        this.language = '';
        this.helpCenterUrl = '';
        this.plans = '';
        this.allowedDomains = [];
        this.allowedEmails = [];
    }
}
